'use client';
import { useRef } from 'react';
import { composeEventHandlersUtil } from '../utilities/compose-event-handlers.util.js';
import { createClickOnSpaceHandler, createClickOnEnterHandler } from '../utilities/event-handlers.util.js';

function useNonButtonElementAsButton(r) {
    let l = useRef(null), u = {
        role: 'button',
        tabIndex: 0,
        onKeyPress: composeEventHandlersUtil(r, createClickOnEnterHandler(l), createClickOnSpaceHandler(l))
    };
    return [
        l,
        u
    ];
}
function useNonAnchorElementAsAnchor(o) {
    let r = useRef(null), l = {
        role: 'link',
        tabIndex: 0,
        onKeyPress: composeEventHandlersUtil(o, createClickOnEnterHandler(r))
    };
    return [
        r,
        l
    ];
}

export { useNonAnchorElementAsAnchor, useNonButtonElementAsButton };
